import { createContext, useState } from "react"

const ThemeContext = createContext()

const ThemeContextProvider = ({ children }) => {

    const [Theme, setTheme] = useState("light")
    const changeTheme = () => {
        if (Theme === 'light') setTheme('dark')
        else setTheme("light")
    }
    return <ThemeContext.Provider value={{ Theme, changeTheme }} >
        {children}
    </ThemeContext.Provider>
}

export { ThemeContext, ThemeContextProvider }